import { menuAnatomy as r } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as i, cssVar as n, defineStyle as e } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig: s, definePartsStyle: a } = i(r.keys), t = n("menu-bg"), o = n("menu-shadow"), l = e({
  [t.variable]: "#fff",
  [o.variable]: "shadows.sm",
  _dark: {
    [t.variable]: "colors.gray.700",
    [o.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: "dropdown",
  borderRadius: "md",
  borderWidth: "1px",
  bg: t.reference,
  boxShadow: o.reference
}), d = e({
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _disabled: {
    color: "gray.200",
    cursor: "not-allowed"
  },
  bg: t.reference
}), c = e({
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}), m = e({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}), b = e({
  opacity: 0.6
}), y = e({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}), f = e({
  transitionProperty: "common",
  transitionDuration: "normal"
}), u = a({
  button: f,
  list: l,
  item: d,
  groupTitle: c,
  icon: m,
  command: b,
  divider: y
}), g = s({
  baseStyle: u
});
export {
  g as menuTheme
};
